export const formatCurrency = num => {
    if (num !== undefined && num !== null) {
        return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
        return "$" + 0.0;
    }
};
